import { MetaTags } from '@cedarjs/web'
import IntegrationsList from './components/IntegrationsList'
import AircraftIntegrationsList from './components/AircraftIntegrationsList'
import IntegrationSecretsManager from './components/IntegrationSecretsManager'
import { Grid, Box, Tabs, Tab } from '@mui/material'
import { useState } from 'react'

const IntegrationsPage = () => {
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <>
      <MetaTags
        title="Admin Integrations"
        description="Admin Integrations page"
      />
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 3 }}>
          <Tab label="Integrations Overview" />
          <Tab label="Aircraft Integrations" />
          <Tab label="Secrets Management" />
        </Tabs>

        {activeTab === 0 && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              <IntegrationsList />
            </Grid>
            <Grid item xs={12} md={7}>
              <AircraftIntegrationsList />
            </Grid>
          </Grid>
        )}

        {activeTab === 1 && <AircraftIntegrationsList />}

        {activeTab === 2 && <IntegrationSecretsManager />}
      </Box>
    </>
  )
}

export default IntegrationsPage
